/**
 * Die Anzeige einer laufenden Nummer: Präfix und führende Nullen.
 *
 * ═══ WARUM DAS HIER STEHT UND NICHT IM BAUTEIL (Befund 30.08.2026) ═══════
 *
 * Der Betreiber meldete: „Im zusammengesetzten Text wird aus einer laufenden
 * Nr. TK-0001 nur die Nr. 1."
 *
 * Die Formatierung steckte ausschliesslich in `DbSequenceField.vue`. Wer den
 * Wert anderswo anzeigt — der zusammengesetzte Text, eine Listenspalte, ein
 * Verweis, ein Export — bekam die nackte Zahl. `getDisplayValueFn`, die
 * gemeinsame Stelle für genau diese Frage, kannte den Feldtyp gar nicht.
 *
 * EIN FORMAT, DAS NUR AN EINER STELLE GILT, IST KEIN FORMAT. Es fällt erst
 * auf, wenn jemand das Feld ein zweites Mal verwendet — und dann sieht es aus
 * wie ein Fehler in der Verwendung, nicht in der Anzeige.
 *
 * DIE VORGABEN sind dieselben wie im Feld-Editor: vier Stellen, Präfix `#`.
 */
export function laufendeNummerText(
  wert: unknown,
  feldDef?: { prefix?: string | null; padLength?: number | null } | null,
): string {
  if (wert === null || wert === undefined || wert === '') return '';
  const zahl = Number(wert);
  if (!Number.isFinite(zahl)) return String(wert);
  const stellen = feldDef?.padLength ?? 4;
  const praefix = feldDef?.prefix ?? '#';
  return praefix + String(zahl).padStart(stellen, '0');
}
